import { render, staticRenderFns } from "./PlainMessageComponent.vue?vue&type=template&id=e15acd5c&scoped=true"
import script from "./PlainMessageComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./PlainMessageComponent.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PlainMessageComponent.vue?vue&type=style&index=0&id=e15acd5c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e15acd5c",
  null
  
)

export default component.exports